import React from "react";
import { useSelector } from "react-redux";
import ItemCard from "./ItemCard";

const ItemList = () => {
  const items = useSelector((state) => state?.cart);
  // Total item calculate
  const totalItem = items.reduce(
    (prevItem, product) => prevItem + product.quantity,
    0
  );

  return (
    <div className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
      {items?.map((product) => (
        <ItemCard key={product?.id} product={product} />
      ))}

      <div className="flex justify-center items-center text-center">
        <div className="text-xl font-semibold">
          <p>Total Item</p>
          <p className="text-5xl">{totalItem}</p>
        </div>
      </div>
    </div>
  );
};

export default ItemList;
